import React from 'react';
import { HomePage } from './pages/HomePage';
export function App() {
  return <HomePage data-id="element-0" />;
}